export default __webpack_public_path__ + "static/stacked-column-38dc55766adfa97cff1c5675cfe4960c.png";